import { RouterProvider } from "react-router-dom";
import ModalContainer from "./components/modal/modal-container";
import ToastContainer from "./components/toast/toast.container";
import router from "./router";
import "./styles/app.scss";
import Loading from "@core/components/loading";
import { useEffect } from "react";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { BUCKET_URL_KEY, USER_INFO_KEY } from "./constants";
import StorageService from "@core/services/storage";
import { useDispatch } from "react-redux";
import { clearUser, storeUser } from "./store/auth";
import axios from "axios";
import { Environment } from "@environments/environment";
import HttpService from "@core/services/http/http.service";
import { GetDetailResponse, User } from "./types";
import { clearLocalStorage } from "./utils/util";
import { BucketUrl } from "./types/setting.type";

function App() {
  const { abortController } = useCancellationRequest();

  const dispatch = useDispatch();

  useEffect(() => {
    const accessToken = HttpService.getAccessToken();

    axios
      .get<GetDetailResponse<User>>(
        `${Environment.BASE_API}/admin/api/v1/auth/info`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          signal: abortController.signal,
        }
      )
      .then((res) => {
        StorageService.setObject(USER_INFO_KEY, res.data.data);
        dispatch(storeUser(res.data.data));
      })
      .catch(() => {
        clearLocalStorage();
        dispatch(clearUser());
      });
  }, []);

  useEffect(() => {
    axios
      .get<GetDetailResponse<BucketUrl>>(
        `${Environment.BASE_API}/admin/api/v3/setting/bucket-url`,
      )
      .then((res) => {
        const bucketUrl = res.data.data.value || "";

        StorageService.setObject(BUCKET_URL_KEY, bucketUrl);
      })
      .catch(() => {
        clearLocalStorage();
      });
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <div id="toast-root">
        <ToastContainer />
      </div>
      <div id="modal-root">
        <ModalContainer />
      </div>
      <div id="loading-root">
        <Loading />
      </div>
    </>
  );
}

export default App;
